(function(){
  'use strict';
  var root = document.querySelector('[data-cart-page]');
  if(!root || root.getAttribute('data-cart-ready')) return;
  root.setAttribute('data-cart-ready','true');
  var busy = false;
  var checkoutRequested = false;
  var base = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';

  function status(message, error){
    var node = root.querySelector('[data-cart-status]');
    if(node){ node.textContent = message; node.classList.toggle('is-error',!!error); }
  }
  function setBusy(value){
    busy = value;
    root.setAttribute('aria-busy',String(value));
    root.querySelectorAll('[data-cart-quantity]').forEach(function(input){ input.readOnly = value; });
    var express = root.querySelector('.cart-express');
    if(express) express.inert = value;
    var checkout = root.querySelector('[name="checkout"]');
    if(checkout) checkout.textContent = value ? 'Updating cart…' : 'Secure checkout';
  }
  function valid(input){
    if(input.validity.valid && input.value !== '' && Number.isInteger(Number(input.value))) return true;
    var message = 'Please enter a whole-number quantity of 0 or more.';
    if(input.validity.rangeOverflow) message = 'Only '+input.max+' available. Please reduce the quantity.';
    status(message,true);
    input.setAttribute('aria-invalid','true');
    return false;
  }
  function update(input){
    if(!valid(input)) return;
    input.setAttribute('aria-invalid','false');
    if(input.value === input.getAttribute('data-saved-quantity')) return;
    var key = input.getAttribute('data-line-key');
    var sectionId = root.getAttribute('data-section-id');
    setBusy(true);
    status('Updating your cart…',false);
    fetch(base+'cart/change.js',{
      method:'POST', credentials:'same-origin',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify({id:key,quantity:Number(input.value),sections:[sectionId],sections_url:base+'cart'})
    }).then(function(response){
      return response.json().then(function(cart){
        if(!response.ok) throw new Error(cart.description || cart.message || 'Could not update your cart. Please try again.');
        return cart;
      });
    }).then(function(cart){
      var html = cart.sections && cart.sections[sectionId];
      var updated = html && new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-page]');
      if(!updated){
        window.location.assign(checkoutRequested && cart.item_count ? base+'checkout' : base+'cart');
        return;
      }
      root.innerHTML = updated.innerHTML;
      setBusy(false);
      document.querySelectorAll('.hh-cart-count').forEach(function(node){ node.textContent = cart.item_count; });
      status('Cart updated.',false);
      if(checkoutRequested && cart.item_count){
        checkoutRequested = false;
        var form = root.querySelector('form');
        var checkout = root.querySelector('[name="checkout"]');
        if(form && checkout) form.requestSubmit(checkout);
      }else{
        checkoutRequested = false;
        var focusTarget = Array.prototype.find.call(root.querySelectorAll('[data-cart-quantity]'),function(node){ return node.getAttribute('data-line-key') === key; });
        if(!focusTarget) focusTarget = root.querySelector('[name="checkout"],.cart-empty a');
        if(focusTarget) focusTarget.focus({preventScroll:true});
      }
    }).catch(function(error){
      setBusy(false);
      checkoutRequested = false;
      status(error.message || 'Could not update your cart. Please try again.',true);
    });
  }
  root.addEventListener('change',function(event){
    if(event.target.matches('[data-cart-quantity]') && !busy) update(event.target);
  });
  root.addEventListener('invalid',function(event){
    if(event.target.matches('[data-cart-quantity]')) valid(event.target);
  },true);
  root.addEventListener('submit',function(event){
    if(busy){
      event.preventDefault();
      checkoutRequested = !!(event.submitter && event.submitter.name === 'checkout');
    }
  });
  root.addEventListener('click',function(event){
    if(busy && event.target.closest('.cart-item__remove')) event.preventDefault();
  });
})();
